import { Suspense, type ReactNode } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './Card'
import { Badge } from './Badge'

interface AIInsightCardProps {
  title: string
  insight: ReactNode
  label?: string
  action?: ReactNode
  confidence?: string
  compact?: boolean
}

export function AIInsightCard({ title, insight, label = 'AI Insight', action, confidence, compact }: AIInsightCardProps) {
  return (
    <Card tone="intelligence" padding={compact ? 'sm' : 'md'} className="ai-insight-card">
      <CardHeader>
        <div>
          <Badge tone="gold">{label}</Badge>
          <CardTitle className="intelligence-title ai-insight-title">{title}</CardTitle>
          {confidence && <CardDescription>{confidence}</CardDescription>}
        </div>
      </CardHeader>
      <CardContent>
        <Suspense fallback={<div className="body ai-insight-body">Loading insight...</div>}>
          <div className="body ai-insight-body">{insight}</div>
        </Suspense>
      </CardContent>
      {action && <div className="ui-card-footer">{action}</div>}
    </Card>
  )
}
